<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" />
        <!-- <button @click="(event) => handleButtonPress(event)">New Work Order</button> -->
      </div>
      <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
    </div>


    <div class="currentView">
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector">
            <SearchBar class="gate-search" v-bind:search="search" :searchIcon="true"
              v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Enter Search" />
            
          </div>
        </div>
        <DataTable v-bind:tableData="tableData" v-bind:configuration="selectedItem" v-bind:openModalCallback="() => {
          handleModal(selectedItem);
        }
          " v-bind:search="search" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../ContentHeader";
import * as Constants from "../../js/constants";
import DataTable from "./pageComps/DataTable.vue";
import SearchBar from "./pageComps/Search.vue";
import CTSRepository from "../../js/CTSRepository";
// import Insights from "../layout/Insights.vue";

export default {
  components: {
    ContentHeader,
    DataTable,
    SearchBar,
    // Insights
  },
  props: ["organizationData"],
  watch: {
    organizationData: function () {
      //this.communityId = newVal.organization_id
      this.communityId = "nautica2"
      this.performSearch()
    }
  },
  data() {
    return {
      communityId: this.$props.organizationData.organization_id,
      selectedItem: Constants.MAINTENANCE,
      headerName: Constants.MAINTENANCE,
      filters: [],
      tableData: [],
      search: "",
      cardInfo: Constants.DEFAULT_CARD_INFO
    };
  },
  created() {
    this.performSearch("").then((apiData) => {
      console.log("Finished getting and setting API Data", apiData);
    });
  },
  methods: {
    performSearch(data) {
      if (this.communityId == undefined) {
        return
      }
      this.search = data
      return new CTSRepository(this.$props.organizationData).getAllMaintenanceOrders()
        .then((data) => {
          console.log("Search Data", data);
          this.tableData = data.data
        })
        .catch((err) => {
          console.log("Error fetching all Maintenance Orders", err)
        });
    },
    handleButtonPress() {
      if (this.communityId == undefined) {
        return
      }
      let shouldShowModal = false
      if (shouldShowModal) {
        this.$modal.show(Constants.CREATE_MAINTENANCE_MODAL)
        return
      }
      new CTSRepository(this.$props.organizationData).createMaintenanceOrder(JSON.stringify({
        type: "Stove not working - Kitchen",
        title: "Someone created an Maintenance Order from Gatewatch at the Front Office",
        description: "Maintenance Order Created from Gatewatch",
        current_status: "OPEN",
        category: "Appliance",
        priority: "High",
        location: "Kitchen",
        reporter: "4474d2f0-06b4-4a8b-b274-12aa154f7822",
        resident_uid: "ba831a9a-3efc-4ea6-9ec0-30cf497661e3",
        assignee: "ba831a9a-3efc-4ea6-9ec0-30cf497661e3"
      }))
        .then((data) => {
          console.log("Create Maintenance Response", data)
        })
        .catch((err) => {
          console.log("Error creating Maintenance Order", err)
        });
    }
  },
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  widows: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
  display: inline;
  margin-right: 16px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.pageHeader button {
  background-color: #1890FFCC;
  color: white;
}

.filterIcon {
  margin-right: 16px;
  display: inline;

}

.iconGroup {
  display: inline;
}
</style>